module.exports = __webpack_public_path__ + "img/live-streams.b4f519ca.png";